module.exports = __webpack_public_path__ + "static/media/web_goshare_step2.8ce775a0.mp4";